import { render, staticRenderFns } from "./NoImage.vue?vue&type=template&id=31164e18&scoped=true&"
import script from "./NoImage.vue?vue&type=script&lang=js&"
export * from "./NoImage.vue?vue&type=script&lang=js&"
import style0 from "./NoImage.vue?vue&type=style&index=0&id=31164e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31164e18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VImg,VProgressCircular})
